import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/forms.css";
import "./styles/dashboard.css";
import {AuthProvider} from "./context/AuthContext";

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);